import React from 'react';
import '../../styles/seminarHall.css';  // Import the separate CSS file for styling

const SeminarHall = () => {
  return (
    <div className="seminar-container">
      <h1 className="seminar-title">SEMINAR HALL / AUDITORIUM</h1>
      <div className="seminar-content">
        <div className="seminar-description">
          <p>
            PA Polytechnic College features state-of-the-art seminar halls equipped with modern amenities to host various academic and extracurricular events. 
            The halls are designed to facilitate guest lectures, workshops, and interactive sessions, providing students with opportunities for knowledge enhancement and skill development. 
            With comfortable seating arrangements, advanced audio-visual systems, and air-conditioning, the seminar halls create an ideal learning environment. 
            These spaces are also utilized for faculty training programs, industry interactions, and student presentations, ensuring a well-rounded educational experience.
          </p>
        </div>
        <div className="seminar-images">
          <div className="seminar-image">
            <img src="/images/audi.jpg" alt="Seminar Hall 1" />
          </div>
          <div className="seminar-image">
            <img src="/images/audi1.jpg" alt="Seminar Hall 2" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeminarHall;